import { PagesItem } from './components/PagesItem';
import { sidebarPagesList } from './config';

export const Pages = () => {
  return (
    <div className="w-full flex flex-col justify-center items-center gap-1">
      {sidebarPagesList.map((option) => (
        <PagesItem option={option} key={option.title} />
      ))}
    </div>
  );
};
